// extracted by mini-css-extract-plugin
export default {"plans":"Plans-module--plans--D0y3I","title":"Plans-module--title--Uibff","container":"Plans-module--container--5ZX0g"};